import React, { createContext, useReducer, useEffect } from "react";
import { useSelector } from "react-redux";
import themes from "../../styles/theme/themeColors";
import useReducerLogger from "../utils/useReducerLogger";

export const ThemeContext = createContext();

const initialState = {
  activeTheme: "light",
  themes: themes,
};

const themeReducer = (state, action) => {
  switch (action.theme) {
    case "light":
    case "dark":
    case "lightOpenx":
      return { ...state, activeTheme: action.theme };
    default:
      return state;
  }
};

export function ThemeProvider(props) {
  const user = useSelector((state) => state.user);
  const [state, dispatch] = useReducer(
    useReducerLogger(themeReducer),
    initialState
  );

  useEffect(() => {
    if (user?.reqMetadata?.organization === "OpenX") {
      dispatch({ theme: "lightOpenx" });
    } else {
      dispatch({ theme: "light" });
    }
  }, [user]);

  return (
    <ThemeContext.Provider value={{ state, dispatch }}>
      {props.children}
    </ThemeContext.Provider>
  );
}
